module.exports = __webpack_public_path__ + "static/media/icon-dc.81531b32.svg";